import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Pane } from '../Pane';
import { getPagePromptHeaderId, PromptHeader } from '../PromptHeader';
import { AutoInteractionBar } from '../AutoInteractionBar';
import { Media } from '../Media';
import { SectionState } from '../../store/section/SectionState';
import { exposeTestId } from '../../config';
import { connect } from 'react-redux';
import { MaximizedLayout } from '../MaximizedLayout';
import { useCustomReportAreaOverlay } from '../CustomOverlay';
import { selectLayoutState, selectPromptHeaderFlexDirection, selectPromptHeaderState, } from '../../store/selectors';
import { ReportSectionZeroState } from '../ReportSectionZeroState';
import { bindActionCreators } from 'redux';
const ReportSectionBase = forwardRef(function (props, ref) {
    let isActiveSection;
    {
        let activeSection;
        const { hiddenSection, currentSection } = props.sectionState;
        if (hiddenSection) {
            activeSection = hiddenSection;
        }
        else {
            activeSection = currentSection ? props.sectionState.byId[currentSection] : undefined;
        }
        isActiveSection = (activeSection === null || activeSection === void 0 ? void 0 : activeSection.id) === props.data.id;
    }
    const CustomReportAreaOverlay = useCustomReportAreaOverlay();
    const renderMedia = () => {
        if (!props.hasContent) {
            return (_jsx(ReportSectionZeroState, { hideAutoChartButton: !props.sectionState.showCreateAutoChart, emptyViewEditable: props.sectionState.emptyViewEditable, onPressCreateAutoChart: () => {
                    props.actions.notifyPressCreateAutoChart(props.data.id);
                }, onPressSelectTemplate: () => {
                    props.actions.notifyPressSelectTemplate(props.data.id);
                }, onPressExploreSuggestions: () => {
                    props.actions.notifyPressExploreSuggestions(props.data.id);
                } }));
        }
        else {
            return _jsx(Media, { id: props.data.rootContainerId });
        }
    };
    // Determines whether the padding is too small to display prompt header control arrows
    const smallPadding = parseInt(props.data.padding || '') < 16;
    if (!props.data.rootContainerId)
        return null;
    return (_jsxs(Pane, Object.assign({ style: Object.assign({ display: props.hide ? 'none' : 'flex', flexGrow: 1, flexBasis: 0, overflow: 'hidden', flexDirection: props.headerFlexDirection, backgroundColor: props.reportBackgroundColor }, props.style), ref: ref, onContextMenu: props.onContextMenu, "data-testid": exposeTestId() ? props.data.id : undefined }, { children: [_jsx(PromptHeader, { id: getPagePromptHeaderId(props.data.rootContainerId), type: "page", viewMode: !props.sectionState.emptyViewEditable, hiddenNavigation: props.hideNavigation, reportPromptHeaderHasHover: props.promptHeaderHover, hideArrow: smallPadding, padding: props.data.padding }), _jsxs("div", Object.assign({ "data-testid": exposeTestId() ? props.data.rootContainerId : undefined, style: {
                    position: 'relative',
                    display: 'flex',
                    flexBasis: 0,
                    flexGrow: 1,
                    flexDirection: 'column',
                    padding: props.headerLocation === 'top'
                        ? `0 ${props.data.padding} ${props.data.padding}`
                        : props.data.padding,
                } }, { children: [_jsx(AutoInteractionBar, { id: props.data.rootContainerId }), isActiveSection && props.maximizedVisual ? (_jsx(MaximizedLayout, { id: props.maximizedVisual })) : (renderMedia()), CustomReportAreaOverlay && (_jsx(CustomReportAreaOverlay, { id: props.data.rootContainerId, type: "section" }))] }))] })));
});
export const ReportSection = connect((state, props) => {
    var _a, _b, _c, _d, _e;
    const headerId = getPagePromptHeaderId(props.data.rootContainerId || '');
    return {
        maximizedVisual: state.bird.maximizedVisual,
        sectionState: state.sections,
        reportBackgroundColor: (_a = state.bird.reportBackgroundColor) !== null && _a !== void 0 ? _a : undefined,
        hasContent: !!((_c = selectLayoutState(state, (_b = props.data.rootContainerId) !== null && _b !== void 0 ? _b : '').childKeys) === null || _c === void 0 ? void 0 : _c.length) ||
            !!((_d = selectLayoutState(state, headerId).childKeys) === null || _d === void 0 ? void 0 : _d.length),
        headerFlexDirection: selectPromptHeaderFlexDirection(state, headerId),
        headerLocation: (_e = selectPromptHeaderState(state, headerId)) === null || _e === void 0 ? void 0 : _e.location,
    };
}, (dispatch) => ({
    actions: bindActionCreators(SectionState.actions, dispatch),
}), undefined, { forwardRef: true })(ReportSectionBase);
